<template>
  <header class="page_header">
    <title>青空クリニック | 富山市堀 上堀駅の内科・皮膚科・泌尿器科</title>
    <div class="page_header-content" v-fade-in>
      <h1 style="margin: 10px 0 0 0;">医療法人社団青空会</h1>
      <h1 style="margin-bottom: 0px;">青空クリニック</h1>
      <img alt="Aozora logo" src="../assets/images/aozora_logo_name.png" class="display-logo" width="250" height="30.23"/>
      <p style="margin-bottom: 0px; font-weight: bold; color: #fff;">内科・皮膚科・泌尿器科</p>
    </div>
  </header>
</template>

<script>
export default {
  name: "PageHeader",
};
</script>

<style scoped>
h1 {
  padding-top: 10px;
}

.page_header {
  display: flex;
  justify-content: center; /* 横方向の中央揃え */
  align-items: center;    /* 縦方向の中央揃え */
  color: #343434;
  min-height: 40vh;      /* 内容がはみ出さないよう、最低高さのみ指定 */
  flex-shrink: 0;         /* 親(.overlay-image)が縦に狭いときに潰されてClinicScheduleと重ならないようにする */
  text-align: center;
  margin-top: 0; /* navの高さ120px + 余白20pxを確保 */
  position: relative;
  z-index: 1; /* navより下に配置 */
}

.page_header-content {
  min-height: 350px;
  display: flex;
  flex-direction: column; /* 縦方向に配置 */
  justify-content: center;
  align-items: center;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.7), 0 0 16px rgba(255, 255, 255, 0.5);
}

@media (max-width: 768px) {
  .page_header {
    margin-top: 0; /* モバイル版navの高さ114px + 余白16pxを確保 */
  }

  .page_header-content {
    min-height: 270px;
  }
}
</style>
